module.exports = __webpack_public_path__ + "img/media-library-upload-highlight.5197cc18.png";